module.exports = __webpack_public_path__ + "img/zabezpecovaci-zarizeni.fa688032.svg";